import { chartColorsMixin } from "@/modules/global/mixins/chartColorsMixin.js";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      pChart: {
        data: null,
        extraOptions: null
      },
      rChart: {
        data: null,
        extraOptions: null
      },
      progressArray: [],
      completedAssessmentResults: [],
      baseChartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        responsive: true
      }
      // green: "#90BF3E",
      // yellow: "#FFD543",
      // red: "#D4181B"
    };
  },
  mixins: [chartColorsMixin],
  mounted() {
    this.AllUserProgressArrays();
    this.AllUsersResultsArrays();
  },
  computed: {
    ...mapGetters({
      getFilteredList: "globalStore/getFilteredList",
      getChangedLearnersData: "globalStore/getChangedLearnersData"
    }),
    ...mapState({
      activeLearnerModal: state =>
        state.globalStore.settings.isLearnerModalActive
    }),
    totalUsersByFilters() {
      if (this.userData.length > 0) {
        return this.arrayLength(this.userData);
      }
      return 0;
    },
    totalAssessmentsCompletedAllThreads() {
      let totalAssessments = 0;
      if (this.userData.length > 0) {
        this.userData.filter(user => {
          if (
            user.assessmentStates[0].threads[this.threadId].progress === 100 ||
            user.assessmentStates[0].threads[this.threadId].reassess
          ) {
            totalAssessments = totalAssessments + 1;
          }
        });
        return totalAssessments;
      }
      return totalAssessments;
    },
    startedCatchup() {
      let startedCatchup = 0;
      if (this.userData.length > 0) {
        this.userData.forEach((user, index) => {
          let feedback = user.assessmentStates[0].feedback.find(
            thread => thread.threadId == this.threadId + 1
          );
          if (feedback) {
            let notMastered = [];
            feedback.conceptMastery.forEach((concept, index) => {
              if (concept !== 3) notMastered.push(index);
            });
            let currentConcept = user.catchupStates[0].threads[this.threadId]
              .stage
              ? user.catchupStates[0].threads[this.threadId].stage.concept
              : 0;
            let findCurrentConcept = notMastered.findIndex(
              i => i == currentConcept - 1
            );
            if (
              findCurrentConcept > 0 ||
              (findCurrentConcept == -1 &&
                currentConcept !== 0 &&
                notMastered.length > 0)
            ) {
              startedCatchup += 1;
            }
          }
        });
      }
      return startedCatchup;
    },
    completedAssessments() {
      if (this.userData.length > 0) {
        return this.userData.filter(
          user =>
            user.assessmentStates[0].threads[this.threadId].progress === 100
        );
      }
      return [];
    },
    AssessmentNotStarted() {
      if (this.userData.length > 0) {
        return this.userData.filter(
          user => user.assessmentStates[0].threads[this.threadId].progress === 0
        );
      }
      return [];
    },
    MiddleOfAssessment() {
      if (this.userData.length > 0) {
        return this.userData.filter(
          user =>
            user.assessmentStates[0].threads[this.threadId].progress > 0 &&
            user.assessmentStates[0].threads[this.threadId].progress < 100
        );
      }
      return [];
    }
  },
  methods: {
    ...mapMutations({
      updateLearnerModal: "globalStore/updateIsLearnerModalActive",
      updateActiveLearner: "globalStore/updateActiveUser"
    }),
    chartPicker() { },
    arrayLength(array) {
      return array.length;
    },
    getGradeColor(grade) {
      switch (this.assessmentType) {
        case "MATHS_JUNIOR_PRIMARY":
          if (grade <= 1) {
            return this.red;
          } else if (grade <= 2) {
            return this.yellow;
          } else {
            return this.green;
          }
        case "MATHS_SENIOR_PRIMARY":
        case "ENGLISH_SENIOR_PRIMARY":
          if (grade <= 1) {
            return this.red;
          } else if (grade <= 5) {
            return this.yellow;
          } else {
            return this.green;
          }
        case "MATHS_JUNIOR_HIGH":
        case "ENGLISH_JUNIOR_HIGH":
        case "MATHS_MATRIC_FOUNDATIONS":
        default:
          if (grade <= 3) {
            return this.red;
          } else if (grade <= 8) {
            return this.yellow;
          } else {
            return this.green;
          }
      }
    },
    getProgressColor(progress) {
      if (progress === 100) {
        return this.green;
      } else if (progress === 0) {
        return this.red;
      } else {
        return this.yellow;
      }
    },
    compareMasteredGrade(a, b) {
      const user1 = a.assessmentStates[0].feedback.find(
        thread => thread.threadId === this.threadId + 1
      ).gradeMastered;
      const user2 = b.assessmentStates[0].feedback.find(
        thread => thread.threadId === this.threadId + 1
      ).gradeMastered;
      if (user1 > user2) {
        return 1;
      } else if (user1 < user2) {
        return -1;
      } else {
        return 0;
      }
    },
    compareAssessmentProgress(a, b) {
      let user1 = null;
      let user2 = null;

      const user1CatchupState = a.catchupStates.find(
        catchupState => catchupState.assessmentId === a.assessmentStates[0]._id
      );

      const user1ConceptThread = user1CatchupState.threads.find(
        thread => thread.threadId === this.threadId + 1
      );

      if (user1ConceptThread) {
        const user1ConceptMastery = user1ConceptThread.conceptMastery;
        if (user1ConceptMastery) {
          const mastered = user1ConceptMastery.filter(concept => concept === 3)
            .length;

          if (mastered === user1ConceptMastery.length) {
            user1 = 100;
          } else {
            user1 = a.assessmentStates[0].threads[this.threadId].progress;
          }
        }
      }

      const user2CatchupState = b.catchupStates.find(
        catchupState => catchupState.assessmentId === b.assessmentStates[0]._id
      );

      const user2ConceptThread = user2CatchupState.threads.find(
        thread => thread.threadId === this.threadId + 1
      );

      if (user2ConceptThread) {
        const user2ConceptMastery = user2ConceptThread.conceptMastery;
        if (user2ConceptMastery) {
          const mastered = user2ConceptMastery.filter(concept => concept === 3)
            .length;

          if (mastered === user2ConceptMastery.length) {
            user2 = 100;
          } else {
            user2 = b.assessmentStates[0].threads[this.threadId].progress;
          }
        }
      }

      if (user1 > user2) {
        return 1;
      } else if (user1 < user2) {
        return -1;
      } else {
        return 0;
      }
    },
    AllUsersResultsArrays() {
      let labels = [];
      let data = [];
      this.completedAssessmentResults = this.userData
        .filter(user => {
          return (
            user.assessmentStates &&
            user.assessmentStates.length > 0 &&
            user.assessmentStates[0].threads[this.threadId].progress === 100
          );
        })
        .filter(user => {
          return (
            user.assessmentStates[0].feedback.length > 0 &&
            user.assessmentStates[0].feedback.find(
              thread => thread.threadId === this.threadId + 1
            )
          );
        })
        .sort(this.compareMasteredGrade);

      this.completedAssessmentResults.forEach(user => {
        data.push(
          user.assessmentStates[0].feedback.find(
            thread => thread.threadId === this.threadId + 1
          ).gradeMastered
        );
        labels.push(`${user.firstName} ${user.lastName}`);
      });

      this.createBarChart({
        data: data,
        labels: labels,
        xAxis: "Users",
        yAxis: "Grade Mastered At",
        percentSign: false,
        chartType: 2
      });
    },
    async AllUserProgressArrays() {
      let data = [];
      let labels = [];
      let that = this;
      this.progressArray = this.userData
        .filter(user => {
          return user.assessmentStates[0].threads[this.threadId].progress >= 0;
        })
        .sort(this.compareAssessmentProgress);

      await this.progressArray.forEach(async user => {
        // const catchupState = user.catchupStates.find(
        //   catchupState =>
        //     catchupState.assessmentId === user.assessmentStates[0]._id
        // );

        // const conceptThread = await catchupState.threads.find(
        //   thread => thread.threadId === that.threadId + 1
        // );

        // if (conceptThread) {
        //   const conceptMastery = await conceptThread.conceptMastery;
        //   if (conceptMastery) {
        //     const mastered = conceptMastery.filter(concept => concept === 3)
        //       .length;

        //     if (mastered === conceptMastery.length) {
        //       data.push(100);
        //     } else {
        //       data.push(
        //         user.assessmentStates[0].threads[that.threadId].progress
        //       );
        //     }

        //     labels.push(`${user.firstName} ${user.lastName}`);
        //   }
        // } else {
        //   data.push(user.assessmentStates[0].threads[that.threadId].progress);
        //   labels.push(`${user.firstName} ${user.lastName}`);
        // }

        data.push({
          progress: user.assessmentStates[0].threads[this.threadId].progress,
          label: `${user.firstName} ${user.lastName}`
        });
        // labels.push(`${user.firstName} ${user.lastName}`);
      });

      // // Sort data and labels by progress
      // data.forEach((value, index) => {
      //   if (value === 100) {
      //     data.splice(index, 1);
      //     data.unshift(value);
      //     labels.splice(index, 1);
      //     labels.unshift(labels[index]);
      //   }
      // });

      // Sort data and labels by progress in ascending order
      data.sort((a, b) => a.progress - b.progress);

      this.createBarChart({
        data: data.map(item => item.progress),
        labels: data.map(item => item.label),
        xAxis: "Users",
        yAxis: "Progress (%)",
        percentSign: false,
        chartType: 1
      });
      return true;
    },
    // Chart type is a number 1[progress] or 2[results]
    createBarChart(params) {
      let data = {
        datasets: [
          {
            borderColor: context => {
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              return params.chartType === 1
                ? this.getProgressColor(value)
                : this.getGradeColor(value);
            },
            backgroundColor: context => {
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              return params.chartType === 1
                ? this.getProgressColor(value)
                : this.getGradeColor(value);
            },
            minBarLength: context => {
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              if (value === -1) return 0;
              return 2;
            },
            borderWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: params.data
          }
        ],
        labels: params.labels
      };
      let extraOptions = {
        ...this.baseChartOptions,
        scales: {
          yAxes: [
            {
              stacked: false,
              gridLines: {
                drawBorder: true,
                color: "rgba(29,140,248,0.0)"
              },
              scaleLabel: {
                display: true,
                labelString: params.yAxis,
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                beginAtZero: true,
                min: 0,
                fontColor: "#9a9a9a",
                callback: function (value) {
                  if (Number.isInteger(value)) {
                    return `${value}`;
                  }
                }
              }
            }
          ],

          xAxes: [
            {
              stacked: false,
              gridLines: {
                drawBorder: true,
                color: "rgba(225,78,202,0.1)"
              },
              scaleLabel: {
                display: true,
                labelString: params.xAxis,
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: params.ticks ? true : false,
                fontColor: "#9a9a9a"
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            title: (tooltipItem, data) => {
              return "Name: " + data["labels"][tooltipItem[0]["index"]];
            },
            label: (tooltipItem, data) => {
              let percentSign = "";
              let tooltext =
                params.chartType === 1 ? "Progress - " : `Mastered - `;
              return (
                tooltext +
                Math.floor(data["datasets"][0]["data"][tooltipItem.index]) +
                percentSign
              );
            }
            // afterLabel: tooltipItem => {
            //   return userPayload[tooltipItem.index].grade
            //     ? "Actual grade: " + userPayload[tooltipItem.index].grade
            //     : "This is a parent User";
            // }
          }
        },
        hover: {
          onHover: function (e) {
            var point = this.getElementAtEvent(e);
            if (point.length) e.target.style.cursor = "pointer";
            else e.target.style.cursor = "default";
          }
        },
        onClick: (event, item) => {
          if (item.length > 0) {
            let index = item[0]._index;
            if (this.activeLearnerModal) {
              this.threadClicked(index);
            } else {
              this.chartClicked(index, params.chartType);
            }
          }
        }
      };
      if (params.chartType === 1) {
        this.pChart.data = { ...data };
        this.pChart.extraOptions = { ...extraOptions };
      } else if (params.chartType === 2) {
        this.rChart.data = { ...data };
        this.rChart.extraOptions = { ...extraOptions };
      } else if (params.chartType === 3) {
        this.lrChart.data = { ...data };
        this.lrChart.extraOptions = { ...extraOptions };
      } else if (params.chartType === 4) {
        this.lpChart.data = { ...data };
        this.lpChart.extraOptions = { ...extraOptions };
      }
    },
    chartClicked(index, chartType) {
      //this.updateActiveLearnerButton(0);
      if (chartType === 1) {
        this.updateActiveLearner(this.progressArray[index]);
      } else if (chartType === 2) {
        this.updateActiveLearner(this.completedAssessmentResults[index]);
      }
      this.updateLearnerModal(true);
    }
  },
  watch: {
    userData: {
      handler: function () {
        this.AllUserProgressArrays();
        this.AllUsersResultsArrays();
      }
    },
    threadId: {
      handler: function () {
        this.AllUserProgressArrays();
        this.AllUsersResultsArrays();
      }
    }
  }
};
